angular.module('app.services').factory('accountPermission', [
  'userService',
  '$http',
  '$q',
  '$location',
  '$log',
  'api',
  'sharedProperties',
  function(userService, $http, $q, $location, $log, api, sharedProperties) {
    function hasPermission(user, permissionName) {
      if (user && user.ref_user_type)
        return Boolean(
          _.findWhere(user.ref_user_type.ref_permissions, {
            name: permissionName,
          })
        )
    }

    let instance = {
      checkUserType: (
        userTypes,
        REDIRECT_TO_404_IF_PAGE_NOT_ALLOWED_TO_VIEW
      ) => {
        let deferred = $q.defer()

        api.fetchCurrentUser().then(
          response => {
            if (!userTypes.includes(response.data.userType)) {
              deferred.reject()
              if (REDIRECT_TO_404_IF_PAGE_NOT_ALLOWED_TO_VIEW) {
                $location.url('/404')
              } else {
                sharedProperties.logOut()
              }
            } else {
              deferred.resolve()
            }
          },
          error => {
            if (error.status === 440) {
              // $log.error("account-permission: error", response);
              userService.setUser().then(function(user) {
                // $log.error("account-permission: error", user);
                deferred.reject()
                $location.url('/signin')
              })
            }
          }
        )

        return deferred.promise
      },
      isEmailListingAllowed: user =>
        hasPermission(user, 'canViewEmailListingPage'),
      isLawyerListingAllowed: user =>
        hasPermission(user, 'canViewLawyersListingPage'),
      isMatchingLawyersAllowed: user =>
        hasPermission(user, 'canViewMatchingLawyersButton'),
      isLawyersActionsAllowed: user =>
        hasPermission(user, 'canViewLawyerlistingActionButton'),
      isAssignedToActionAllowed: user =>
        hasPermission(user, 'canViewAssignedAdminActionButton'),
      canViewEmployersExportButton: user =>
        hasPermission(user, 'canViewEmployersExportButton'),
      canViewJobsExportButton: user =>
        hasPermission(user, 'canViewJobsExportButton'),
      canViewLawyersExportButton: user =>
        hasPermission(user, 'canViewLawyersExportButton'),
      canExportAllLawyersLawyersListing: user =>
        hasPermission(user, 'canExportAllLawyersLawyersListing'),
      canViewMasterAssignedToFilter: user =>
        hasPermission(user, 'canViewMasterAssignedToFilter'),
      canAddNotesForEmployers: user =>
        hasPermission(user, 'canAddNotesForEmployers'),
      canViewAddFirmAssignedAdmin: user =>
        hasPermission(user, 'canViewAddFirmAssignedAdmin'),
      canNotEditNewUserProfile: user =>
        hasPermission(user, 'canNotEditNewUserProfile'),
      canEditApplicationStages: user =>
        hasPermission(user, 'canEditApplicationStages'),
    }

    return instance
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/services/account-permission.js